<template>
  <div
    class="tabs-container ng-scope"
    style="padding-bottom: 50px; margin-top: 18px"
  >
    <el-form
      :model="schoolDelete"
      ref="schoolDelete"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <div class="tab-content">
        <div class="panel-body">
          <div class="ibox-content">
            <div class="form-group">
              <label class="col-sm-2 control-label">
                User Name <span style="color: red">*</span></label
              >
              <div class="col-sm-10">
                <el-form-item
                  prop="userName"
                  :rules="[
                    {
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    v-model="schoolDelete.userName"
                    :name="'userName'"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">
                Password <span style="color: red">*</span></label
              >
              <div class="col-sm-10">
                <el-form-item
                  prop="password"
                  :rules="[
                    {
                      required: $route.query.id?false:true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    v-model="schoolDelete.password"
                    :name="'password'"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">
                District <span style="color: red">*</span></label
              >
              <div class="col-sm-4">
                <div>
                  <el-select
                    :disabled="userRole==6"
                    v-model="schoolDelete.districtCode"
                    clearable
                    name="districtCode"
                    @change="handleSelectDistrict"
                  >
                    <el-option
                      v-for="district in districtGetlist"
                      :label="district.districtNameEn"
                      :value="district.districtCode"
                      :key="district.districtCode"
                      class="ng-binding"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">
                School <span style="color: red">*</span></label
              >
              <div class="col-sm-4">
                <div>
                  <el-select
                    disabled
                    v-model="schoolDelete.schoolCode"
                    clearable
                    name="districtCode"
                  >
                    <el-option
                      v-for="district in schoolCodeList"
                      :label="district.schoolName"
                      :value="district.schoolCode"
                      :key="district.schoolCode"
                      class="ng-binding"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-sm-2">
                <el-button @click="handleShowModel">School Filter</el-button>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">
                Contact Person Name <span style="color: red">*</span></label
              >
              <div class="col-sm-10">
                <el-form-item
                  prop="contactPersonName"
                  :rules="[
                    {
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    v-model="schoolDelete.contactPersonName"
                    :name="'contactPersonName'"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">
                Contact Person Email <span style="color: red">*</span></label
              >
              <div class="col-sm-10">
                <el-form-item
                  prop="contactPersonEmail"
                  :rules="[
                    {
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    v-model="schoolDelete.contactPersonEmail"
                    :name="'contactPersonEmail'"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">
                Contact Person Tel <span style="color: red">*</span></label
              >
              <div class="col-sm-10">
                <el-form-item
                  prop="contactPersonTel"
                  :rules="[
                    {
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    v-model="schoolDelete.contactPersonTel"
                    :name="'contactPersonTel'"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-12">
                <div class="pull-right">
                  <el-button
                    type="primary"
                    v-if="
                      (checkPermission('Schooluser_LIST_EDIT') &&
                        $route.query.id) ||
                      (checkPermission('Schooluser_LIST_ADD') &&
                        !$route.query.id)
                    "
                    @click="checkEvent()"
                  >
                    {{ $t("message.Save") }}
                  </el-button>
                  <el-button @click="$router.go(-1)">{{
                    $t("message.Cancel")
                  }}</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <schoolSelectModel @add="handleSelectSchool" @close="handleCloseModel" :districtCode="schoolDelete.districtCode" :isShowAddModel="isShowModel"/>
  </div>
</template>
<script>
import config from "../config";
import sha256 from "sha256";
import schoolSelectModel from '../components/schoolSelectModel/index.vue'
export default {
  mixins: [config.globalMixin],
  data() {
    return {
      schoolDelete: {
        contactPersonEmail: "",
        contactPersonName: "",
        contactPersonTel: "",
        districtCode: "",
        password: "",
        schoolCode: "",
        userName: "",
      },
      districtGetlist: [],
      schoolCodeList: [],
      isShowModel:false
    };
  },
  components:{
    schoolSelectModel
  },
  async created() {
    if(this.userRole==6) this.schoolDelete.districtCode = JSON.parse(sessionStorage.getItem("userInfo")).userDistrictCode
    await this.init();
    await this.getDistrictGetlist();
    await this.getSchoolCodeList();
  },
  computed:{
    userRole() {
      const res = JSON.parse(sessionStorage.getItem("userInfo"));
      return res.roleType;
    },
  },
  mounted() {
    
  },
  methods: {
    checkEvent() {
      this.$refs["schoolDelete"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },

    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.schoolUserDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }

        if (data.data.result.startTime) {
          this.period = [data.data.result.startTime, data.data.result.endTime];
        }
        if (!data) return;
        for (var key in this.schoolDelete) {
          this.schoolDelete[key] = data.data.result[key];
        }
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
    },
    async submit() {
      let obj = this.getAuthObj();
      for (var key in this.schoolDelete) {
        obj[key] = this.schoolDelete[key];
      }
      var data;
      if (this.$route.query.id) {
        obj.password = this.schoolDelete.password || ''
        obj.id = this.$route.query.id;
        obj.apiUrl = this.apiConfig.schoolUserUpdate;
        data = await this.$store.dispatch("apiEvent", obj);
      } else {
        obj.apiUrl = this.apiConfig.schoolUserCreate;
        data = await this.$store.dispatch("apiEvent", obj);
      }
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$router.go(-1);
      }
    },
    async getSchoolCodeList() {
      let obj = this.getAuthObj();
      obj.pageIndex = 1
      obj.pageSize = 99999
      obj.districtCode = this.schoolDelete.districtCode || ''
      obj.apiUrl = this.apiConfig.schoolCodeList;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "schoolCodeList", data.data.result.schools);
    },
    async getDistrictGetlist() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtGetlist", data.data.result);
    },
    handleSelectDistrict() {
      this.schoolDelete.schoolCode = "";
      this.getSchoolCodeList();
    },
    handleShowModel(){
      this.isShowModel=true
    },
    handleCloseModel(e){
      this.isShowModel=false
    },
    handleSelectSchool(e){
      this.schoolDelete.schoolCode = e.schoolCode
    }
  },
};
</script>
